import mixitup from 'mixitup'

export default class GalleryFn {
    constructor() {
        this.filtros()
    }
    filtros = () => {
        var containerEl = document.querySelector('.gallery_allImages');

        var mixer = mixitup(containerEl, {

            animation: {
                effects: 'fade translateZ(-100px)'
            }
        });
    }
}
